import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3facdebd")
const _hoisted_1 = { class: "app__header" }
const _hoisted_2 = { class: "app__header__item" }
const _hoisted_3 = { class: "app__header__item center" }
const _hoisted_4 = { class: "app__header__item" }
const _hoisted_5 = { class: "app__header__links" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Сдайте жилье")
_popScopeId()

import { IconTextButton, RoundedIconButton, BurgerButton } from "@/components";
import { IconLogo } from "@/components/icons";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IconLogo))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(IconTextButton))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_unref(RoundedIconButton), { icon: "earth" }),
        _createVNode(_unref(BurgerButton))
      ])
    ])
  ]))
}
}

})